import Contactologia from './Contactologia';

export default Contactologia;
